function HowToReturn() {
  return (
    <p>

      <span style={{ color: "rgb(51, 51, 51)", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
        If you want to return the product for any reason you can do so within 30
        days of delivery provided the part has not been used or damaged by you.
        You can also do a core return at our pick-up location nearby. The part
        should be returned with the original packing and in the same condition
        as it was at the time of delivery. If you have any queries relating to
        the part after the expiry of 30 day period, you can contact the
        manufacturer of the part.
      </span>
    </p>
  );
}
export default HowToReturn;
